import autoSendForwardMassAction from "./autoSendForwardMassAction";

/**
 * Get the processing of a conversation action in the mass actions, same switch as the conversation actions
 * (TabAction): first on the type, then on the subType when a type has several variants.
 *
 * A handler is an object with:
 * 	- isEligible(conversation): the filter of the selection
 * 	- noConversationMessageKey: i18n key displayed when no conversation respects isEligible (optional)
 * 	- renderConfirmDialog({ action, conversationCount, handleClose, handleValidate }): the agent confirmation
 * 	- execute({ action, conversations, result, dispatch }): what is sent, result is the value given to handleValidate
 *
 * To add a mass action: a file in this folder exporting its handler, and its case below.
 * @param {object} action the conversation action of the assistantConfig (scope "conversation", enableMassAction true)
 * @returns {object|null} the handler, null if the action has no mass processing (selection only, no execution)
 */
export function getMassActionHandler(action) {
	if (action?.version !== "2.0") {
		return null;
	}

	switch (action.type) {
		case "forward":
			switch (action.subType) {
				default:
					// The automatic forward is a variant of the configuration, not a subType
					return action.config?.autoSend === true ? autoSendForwardMassAction : null;
			}
		default:
			return null;
	}
}
